import { Pipe, PipeTransform } from '@angular/core';
import { Inscription, Plan } from 'src/app/pages/virtual-class/interfaces';

@Pipe({
  name: 'planEmailDetector',
})
export class PlanEmailDetectorPipe implements PipeTransform {
  transform(value: Inscription | Plan): string {
    console.log('value :>> ', value);
    let data = '';
    if ('paymentPending' in value || 'paymentAprobed' in value) {
      data =
        value.paymentPending?.issuingBank || value.paymentAprobed?.issuingBank;
    } else {
      data = (value as Plan).issuingBank;
    }

    return data.includes('@') ? 'Email:' : 'Banco Emisor:';
  }
}
